import { ClientRemovalsRepository } from "@domain/repositories/ClientRemovalsRepository";
import UseCase from "@domain/UseCase";
import { Client } from "@domain/models/Client";
import { ClientRemoval } from "@domain/models/ClientRemoval";

type Input = Client["id"];

type Output = Promise<ClientRemoval[]>;

export class GetClientRemovalsUseCase implements UseCase<Input, Output> {
  constructor(private readonly clientRemovalsRepository: ClientRemovalsRepository) {}

  execute(clientId: Input) {
    return this.clientRemovalsRepository.getClientRemovals(clientId);
  }
}
